import dashboardBundleService from '@/services/dashboard/event_dashboard_bundle'
import useDateFormatter from '@/composables/useDateFormatter'
import useMessageTypeLabel from '@/composables/useMessageTypeLabel'

const { normalizeDate, formatDate, formatTime } = useDateFormatter()
const { getMessageTypeLabel } = useMessageTypeLabel()

function getStatusLabel(status) {
  switch ((status || '').toLowerCase()) {
    case 'pending': return 'Pendiente'
    case 'in_progress': return 'En proceso'
    case 'done': return 'Finalizado'
    default: return status || '-'
  }
}

function mapItem(item) {
  return {
    ...item,
    dateText: formatDate(item.date),
    timeText: formatTime(item.date),
    typeLabel: getMessageTypeLabel(item.type),
    statusLabel: getStatusLabel(item.status),
    recipients: Number(item.total || 0),
    totals: {
      sent: Number(item.total_send || 0),
      delivered: Number(item.total_delivered || 0),
      read: Number(item.total_read || 0),
      failed: Number(item.total_failed || 0)
    }
  }
}

export default {
  async get(eventId, options = {}) {
    if (!eventId) {
      return []
    }

    try {
      const bundle = await dashboardBundleService.get(eventId, options)
      const items = bundle.history || []

      return items
        .slice()
        .sort((a, b) => {
          const aDate = normalizeDate(a.date)
          const bDate = normalizeDate(b.date)
          const aTime = aDate ? aDate.getTime() : 0
          const bTime = bDate ? bDate.getTime() : 0
          return bTime - aTime
        })
        .slice(0, 5)
        .map(mapItem)
    } catch (error) {
      return []
    }
  },

  invalidate(eventId) {
    dashboardBundleService.invalidate(eventId)
  }
}
